export default "Deseja realmente excluir esta sentença?\n  "